import React from 'react'

import { Rows } from '@/components/layout'
import MailingListOptInForm from '@/components/Pages/EmailPreferences/MailingListOptInForm'

import styles from './BlogSubscribe.module.scss'

const BlogSubscribe = () => (
  <Rows className={styles.wrapper} gap={0}>
    <p>
      <strong>Get Exclusive Resources & Offers</strong><br />
      Subscribe to get tips and offers designed to help grow your business.
    </p>
    <MailingListOptInForm emailOnly />
  </Rows>
)

export default BlogSubscribe
